export default {
    isAuth(state) {
        return state.token;
    },
    getStudentIec(state) {
        return state.student_iec;
    },
    getUserId(state) {
        return state.userId;
    },
    getCourseDetailsInfo(state) {
        return state.courseDetails;
    },
    getCourseId(state) {
        return state.courseId;
    },
    getChallengeIds(state) {
        return state.challengeIds;
      },
    getUserName(state) {
        return state.userName;
    },
    getFirstName(state){
        return state.firstName;
    },
    getLastName(state){
        return state.LastName;
    },
    getParentEmail(state) {
        return state.parentEmail;
    },
    getLessonPreVideo(state) {
        return state.lessonPreVideo;
    },
    getAllowLessonLocking(state) {
        return state.allowLessonLocking;
    },
    getAllowFinishLessons(state) {
        return state.allowfinishLessons;
    },
    getIdeInfo(state) {
        return state.ideInfo;
    },
    getImageCategories(state) {
        return state.imageCateg;
    },
    getImageByCategId(state) {
        return state.imagesByCateg;
    },
    getSoundCategories(state) {
        return state.soundCateg;
    },
    getSoundByCategId(state) {
        return state.soundsByCateg;
    },
    getStudentIndividualProject(state) {
        return state.studentIndividualProject;
    },
    getGraduationProject(state) {
        return state.graduationProject;
    },
    getStudentProfileId(state) {
        return state.studentProfileId;
    },
    getUserProfileId(state) {
        return state.userProfileId;
    },
    getStudentCourseProjects(state) {
        return state.studentCourseProjects;
    },
    getRandomCourseProject(state) {
        return state.randomCourseProject;
    },
    getStudentType(state) {
        return state.StudentType;
    },
    getStudentActiveCourseInfo(state) {
        return state.activeCourse;
    },
    getWatchStory(state) {
        return state.didWatch;
    },
    getSubscriptionPlan(state) {
        return state.planObj;
    },
    getCompetitionPlan(state) {
        return state.competitionPlan;
    },
    getSchoolId(state) {
        return state.schoolId;
    },
    getGoalVisited(state) {
        return state.isGoalVisited;
    },
    getGraduationProjectPlayground(state) {
        return state.graduationProjectPlayground;
    },
    getParentProfileId(state) {
        return state.parentProfileId;
    },
    getHasVisitedIde(state){
        return state.hasVisitedIde;
    },
    getIsSchoolStudent(state){
        return state.isSchoolStudent;
    },
    getIdeVisited(state){
        return state.isVisited;
    },
    getPoints(state){
        return state.points;
    },
    getShowTopTenModal(state){
        return state.showTopTenModal;
    },
    getShowCompetitionModal(state){
        return state.showCompetitionModal;
    },
    getShowWhatsAppModal(state){
        return state.WhatsApp;
    },
    getIsTrial(state){
        return state.isTrial
    },
    getCompetetionInfo(state){
       return state.competitionInfo
    },
    getIsFirstLogin(state){
        return state.isFirstLogin
    },
    getStudentfinishFirstFreeLesson(state){
        return state.studentfinishFirstFreeLesson
    },
    getStudentfinishSecondFreeLesson(state){
        return state.studentfinishSecondFreeLesson
    },
    getStudentfinishThirdFreeLesson(state){
        return state.studentfinishThirdFreeLesson
    },
    getStudentfinishForthFreeLesson(state){
        return state.studentfinishForthFreeLesson
    },
    getStudentfinishFifthFreeLesson(state){
        return state.studentfinishFifthFreeLesson
    },
    getStudentfinishBasicSmoothy(state){
        return state.studentfinishBasicSmoothy
    },
    getStudentfinishIntermediateSmoothy(state){
        return state.studentfinishIntermediateSmoothy
    },
    getStudentfinishAdvancedSmoothY(state){
        return state.studentfinishAdvancedSmoothY
    },
    getStudentfinishExpertSmoothY(state){
        return state.studentfinishExpertSmoothY
    },
    getStudentfinishHTML(state){
        return state.studentfinishHTML
    },
    getIsComeFromGrants(state){
        return state.isComeFromGrants
    },
    getSubscribeNowDiscount(state){
        return state.subscribeNowDiscount
    },
    getSubscribePlanId(state){
        return state.subscribePlanId
    },
    getCliantInfo(state){
        return state.cliantInfo
    },
    getImageEmoji(state){
        return state.img_uri;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js